import styled from 'styled-components';
import * as CSS from 'csstype';
import TickGreenSvg from '../../assets/partner/tick-green.svg';

const TickGreenRound = styled(TickGreenSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.6rem'};
  height: ${props => props.height || '1.6rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default TickGreenRound;
